<template>
  <v-container class="app-page-container">
			<v-card class="shadow-none app-page-card p20" v-if="questions_list.length > 0">
            <div v-if="getShowModalMessageResult">{{processModalResult()}}</div>

                  <v-card-text>
                    <v-card class="shadow-none">
                      <v-layout row wrap>
                        <v-flex xs12>
                          <div class="pagination-action-panel">
                            <v-icon class="pagination-action-panel__icon-btn cursor-pointer" small @click="addPage()">add</v-icon>
                            <v-icon class="pagination-action-panel__icon-btn cursor-pointer" small @click="enableEditMode()">edit</v-icon>
                          </div>
                          <v-pagination v-if="pages > 0"                  
                            v-model="page"
                            class="leaderboard__pagination p20"
                            :length="pages"
                            :total-visible="10"
                            circle
                          />
                        </v-flex>
                        
                      </v-layout>
                    </v-card>
                  </v-card-text>

                  <div v-for="(question, index) in questions_list" :key="index">              
                    <v-card-text v-if="question.page == 0">
                      <v-layout row wrap>                
                        <v-flex xs12>
                          <QueElement v-bind:translations='question.translations' v-bind:qtype='question.q_type' v-bind:q_id="question.id"/>
                        </v-flex>
                      </v-layout>
                    </v-card-text>

                    <v-card-text v-if="question.page == page">
                      <v-layout row wrap>                
                        <v-flex xs12>
                          <QueElement v-bind:translations='question.translations' v-bind:qtype='question.q_type' v-bind:q_id="question.id"/>


                          <!-- |–> src/components/questionaires/que_element.vue

                            <v-layout justify-center>
                            <v-icon v-if="index > 0 " @click="tryDeleteElement(index)">mdi-delete</v-icon>
                            <v-icon v-if="index > 1" @click="changeOrder(index, index-1)">mdi-arrow-up</v-icon>
                            <v-icon v-if="index > 0 && index < questions_list.length-1" @click="changeOrder(index, index+1)">mdi-arrow-down</v-icon>
                          </v-layout>
                          <v-layout justify-center>
                            <v-flex xs2></v-flex>
                            <v-flex xs8>
                              <v-select                           
                                v-model="question.page"
                                :items="page_list"
                                label="page"
                                @input="changePage(index)"
                              ></v-select>
                            </v-flex>
                          <v-flex xs2></v-flex>
                          </v-layout> -->
                          
                        </v-flex>
                      </v-layout>              
                  </v-card-text>
                  </div>
                  <v-card-text v-if="getQueId > 0">
                    <v-layout row wrap>
                      <v-flex xs5></v-flex>
                      
                      <v-flex xs2>
                        <v-menu transition="slide-y-transition" bottom right>
                          <template v-slot:activator="{ on }">
                              <v-btn small color="primary" v-on="on" >
                                Question
                              </v-btn>
                          </template>
                          <v-list>
                            <v-list-item
                              v-for="(item, index) in questions_types"  :key="index"  @click="add_Q(index+1)" >
                              <v-list-item-title>{{ item }}</v-list-item-title>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </v-flex>  
                    </v-layout>
                  </v-card-text>
      </v-card>
	</v-container>
</template>

<script>
import axios from '../../axios-auth.js'
import QueElement from './que_element.vue'
import {mapGetters} from 'vuex'

  export default {
    data() {
      return {
        questions_list: [],
        questionaire_id: 0,
        questions_types: ['description',
                         'one choice',
                         'multi choice ',
                         'one choice with other',
                         'multi choice with other',
                         'free answer',
                         'Likert 5',
                         'Likert 7'
                        ],
        deleteIndex: -1,
        page : 1,
        pages: 1,
        page_list: [],
        editMode: false      

      }
    },
    computed: 
        mapGetters([
                        'getQueId',
                        'getShowModalMessageResult'
                    ])
    ,
    mounted () {
      this.initData()
   },
   components :{
     QueElement,
   },
   methods: {
    initData() {
      this.$store.commit('setBreadCrumbs',[{text: 'Questionaires', href: '/que_list'},
                                           {text: 'Active questionaire', href: '/questionnaire/' + this.$route.params.id}])//#
      this.questionaire_id = parseInt(this.$route.params.id)
      if (this.questionaire_id == 0) {
        this.$store.commit('setQueId', 0)
        this.questions_list = []
        this.questions_list.push({
                id: 0,
                page: 0,
                q_order: 0,
                q_type : 0,
                translations : []
            })        
      } else {
        this.getQuestionaire()
      }
    },
    getQuestionaire() {
        axios.get('/get-questionaire/'+this.$route.params.id, this.$store.getters.getAxiosConfig)
          .then(res => {
              this.questionaire_id = res.data.q_id
              this.$store.commit('setQueId', res.data.q_id)
              this.questions_list = res.data.list
              this.countPages()
          })
          .catch(error => {
              this.$store.commit('setFeedback', error)          
          })
    },
    add_Q(index) {
      this.questions_list.push({
          id: 0,
          page: this.page,
          q_order: 0,
          q_type : index,
          translations : []
      })        
    },
    changeOrder(index1, index2) { 
      const data = {
        id1 : this.questions_list[index1].id,
        id2 : this.questions_list[index2].id,
        order1 : this.questions_list[index1].q_order,
        order2 : this.questions_list[index2].q_order
      }
      axios.post('/change-que-element-order', data, this.$store.getters.getAxiosConfig)
          .then(() => {          
            this.questions_list = []
            this.getQuestionaire()
          })
          .catch(error => {
              this.$store.commit('setFeedback', error)          
          })
      },    
    tryDeleteElement(index) {
        this.deleteIndex = index
        this.$store.commit('setShowModalMessage',
                    {content: 'Are you sure?<br/>You want to delete question?', type: 'warning', 
                    buttons:[], icons:[{text:'close', color:'red', value: 1},{text:'done', color:'green', value: 2} ]})
    },
    processModalResult() {
        const res = this.getShowModalMessageResult
        this.$store.commit('setShowModalMessageResult',null)
        if (res == 2) this.deleteElement()        
    },
    deleteElement(){
      this.feedback = null
      const data = {
          id: this.questions_list[this.deleteIndex].id
      }
      axios.post('/delete-que-element', data, this.$store.getters.getAxiosConfig)
        .then(() => {
            this.questions_list = []
            this.getQuestionaire()
        })
        .catch(error => {
            this.$store.commit('setFeedback', error)          
        })
    },
    refreshPageList() {
      this.page_list = []
      for(let i=1; i <=this.pages; i++) {
        this.page_list.push(i)
      }
    },
    addPage() {
      this.pages = this.pages + 1
      this.refreshPageList()
    },
    deletePage() {
      if (this.pages > 1) this.pages = this.pages - 1
      this.refreshPageList()
    },
    countPages() {
      this.pages = 1
      for(let i = 0; i < this.questions_list.length; i++) {
        if (this.questions_list[i].page > this.pages) this.pages = this.questions_list[i].page
      }
      this.refreshPageList()
    },
    changePage(index) {
      this.feedback = null
      const data = {
          id: this.questions_list[index].id,
          page: this.questions_list[index].page
      }
      axios.post('/change-page-que-element', data, this.$store.getters.getAxiosConfig)
        .then((res) => {
            if (res.data.message != "OK")
              this.$store.commit('setFeedback', res.data.description)          
        })
        .catch(error => {
            this.$store.commit('setFeedback', error)          
        })
    },
    enableEditMode() {
      var paginators = document.getElementsByClassName("v-pagination__item");
          /* eslint-disable no-console */
          for (let item of paginators) {
            console.log(item);
            // potrebujeme evidovat index a dat to do data-atributu
            item.innerHTML = item.innerHTML + "<span class='v-pagination__item-action-btn material-icons'>delete</span>";
          }
          /* eslint-enable no-console */

          // pocas editu môze niekto pridat dalsie stranky a tam taktiez potrebujeme pridat delete btn
    }
   }
  }
</script>

<style>

</style>